export const userRoleLabels = {
  admin: 'Администратор',
  operator: 'Оператор',
}

export function normalizeUserRole(role) {
  return role === 'admin' ? 'admin' : 'operator'
}

export function canCreateOperators(user) {
  return user?.role === 'admin'
}

export function canManageCatalog(user) {
  return user?.role === 'admin'
}

export function userRoleLabel(role) {
  return userRoleLabels[normalizeUserRole(role)]
}

export function routeRedirect(to, user) {
  if (!to.meta?.public && !user) {
    return { name: 'login', query: { next: to.fullPath } }
  }
  if (to.name === 'login' && user) return { name: 'dashboard' }
  if (to.meta?.adminOnly && user?.role !== 'admin') return { name: 'dashboard' }
  return undefined
}

export function validateOperator(form) {
  if (!form.username?.trim()) return 'Введите логин оператора.'
  const username = form.username.trim().toLowerCase()
  const fullName = (form.fullName || '').trim()
  if (Array.from(username).length > 80) return 'Логин должен быть не длиннее 80 символов.'
  if (Array.from(fullName).length > 160) return 'Имя должно быть не длиннее 160 символов.'
  if (/[\u0000-\u001f\u007f]/u.test(username + fullName)) return 'Логин и имя не должны содержать управляющие символы.'
  const passwordLength = typeof form.password === 'string' ? Array.from(form.password).length : 0
  if (passwordLength < 8 || passwordLength > 128) {
    return 'Пароль должен содержать от 8 до 128 символов.'
  }
  return ''
}

export function serializeOperator(form) {
  return {
    username: form.username.trim().toLowerCase(),
    full_name: form.fullName?.trim() || '',
    password: form.password,
  }
}
